import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Skeleton,
  Typography,
} from '@mui/material'
import React, { useEffect, useMemo } from 'react'
import Wizard from '../../components/questions/Wizard'
import MultiQuestion from '../../components/questions/MultiQuestion'
import { useQuery } from 'react-query'
import { BaseService } from '../../services/BaseService'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useQuestionDispatch } from '../../context/QuestionContext/QuestionContext'
import { ADD_QUESTIONS_LIST } from '../../reducers/reducesTypes'
import { useModule } from '../../context/ModuleContext/ModuleContext'
import { moduleTypeIncludes, modulesType } from '../../constants/modules'
import EnumQuestion from '../../components/questions/EnumQuestion'
import MultipleABQuestion from '../../components/questions/MultipleABQuestion'
import EssayLength from '../../components/questions/EssayLength'
import { useGetUser } from '../../hooks/useGetUser'
import DISCQuestion from '../../components/questions/DISCQuestion'
import { useCameraContext } from '../../context/CameraContext/CameraContext'
import { useGeolocationContext } from '../../context/GeolocationContext/GeolocationContext'
import useAntiFocus from '../../hooks/useAntiFocus'
import { useLogging } from '../../context/LoggingContext/LoggingContext'
import useAntiScreenshot from '../../hooks/useAntiScreenshot'
import { getAudioContext, playWarningBeep } from '../../context/AudioContext/AudioContext'
import { removeLocalStorageData } from '../../utils/storage/storage'
import ProctorOverlay from '../../components/Loader/ProctorOverlay'

async function fetchHistory(userId) {
  const service = new BaseService('/m_history_2')
  const res = await service.getHistory({
    id_user: userId,
  })

  return res.data
}
async function fetchQuestion(id) {
  const params = {
    id_modul: id,
  }
  const service = new BaseService('/m_soal_2')
  const res = await service.getQuestion(params)

  return res.data
}

const QuestionPage = () => {
  const { id } = useParams()
  const { user } = useGetUser()
  const dispatch = useQuestionDispatch()
  const { modules } = useModule()
  const {
    permissionGranted: cameraGranted,
    // startCapture,
    stopCapture,
    setModuleId,
    startCameraSession,
    requestCameraPermission,
  } = useCameraContext()
  const { permissionGranted: locationGranted } = useGeolocationContext()
  const [isCameraBlocked, setIsCameraBlocked] = React.useState(false)
  const [isLocationBlocked, setIsLocationBlocked] = React.useState(false)
  const { addLog } = useLogging()
  const { ScreenshotDialog } = useAntiScreenshot({
    userId: user.id,
    moduleId: id,
    addLog,
  })
  const isBeforeUnloadRef = React.useRef(false)
  const cameraStartedRef = React.useRef(false)

  const navigate = useNavigate()
  const location = useLocation()
  const [open, setOpen] = React.useState(false)
  const [showModal, setShowModal] = React.useState(true)
  const [isEnded, setIsEnded] = React.useState(false)

  const { data: dataHistory } = useQuery({
    queryKey: ['rules-history', id],
    queryFn: async () => await fetchHistory(user.id),
  })

  const checkDoneTask = dataHistory?.data?.filter((h) => h.id === id).length > 0

  const { isLoading, data } = useQuery(
    ['question', id],
    async () => {
      const res = await fetchQuestion(id)

      dispatch({
        type: ADD_QUESTIONS_LIST,
        list: res.data,
      })
      return res
    },
    {
      enabled: !!id,
    },
  )

  const rules = useMemo(() => {
    try {
      return typeof modules?.rules === 'string' ? JSON.parse(modules.rules) : modules?.rules || {}
    } catch {
      return {}
    }
  }, [modules?.rules])

  // START: access camera and location
  // blurred when camera and location is not granted
  // useEffect(() => {
  //   if (cameraGranted === false || locationGranted === false) {
  //     setIsBlocked(true)
  //   } else if (cameraGranted === true && locationGranted === true) {
  //     setIsBlocked(false)
  //   }
  // }, [cameraGranted, locationGranted])
  useEffect(() => {
    if (rules.camera !== 1) return
    if (!id) return

    // 🚨 INI YANG BIKIN cameraGranted JADI TRUE
    requestCameraPermission() // getUserMedia
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rules.camera, id])

  useEffect(() => {
    if (rules.camera !== 1) return
    if (cameraGranted !== true) return
    if (cameraStartedRef.current) return

    cameraStartedRef.current = true
    startCameraSession()

    return () => {
      stopCapture()
      cameraStartedRef.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rules.camera, cameraGranted])

  useEffect(() => {
    if (rules.camera === 0) {
      stopCapture()
      cameraStartedRef.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rules.camera])

  useEffect(() => {
    console.log({ A: rules?.camera, B: cameraGranted, C: modules })
    const needCamera = rules?.camera !== 0
    const needGeo = rules?.geo !== 0

    if ((needCamera && cameraGranted === false)) {
      setIsCameraBlocked(true)
    } else {
      setIsCameraBlocked(false)
    }

    if (needGeo && locationGranted === false) {
      setIsLocationBlocked(true)
    } else {
      setIsLocationBlocked(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cameraGranted, locationGranted, modules?.rules])

  // START: init session camera, new mechanism
  // useEffect(() => {
  //   console.log('zzz: ', modules?.rules, { modules, cameraGranted })
  //   // if (rules?.camera === false) return
  //   // if (rules?.camera !== 1) return
  //   if (!cameraGranted) return
  //   if (!id) return
  //   if (cameraStartedRef.current) return

  //   cameraStartedRef.current = true
  //   console.log('lanjut, bakal panggil startCameraSession')
  //   startCameraSession()

  //   return () => {
  //     stopCapture()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [cameraGranted, id, modules?.rules])

  useEffect(() => {
    if (rules?.camera === false) {
      stopCapture()
    }
  }, [rules?.camera, stopCapture])
  // END: init session camera, new mechanism

  useEffect(() => {
    if (id) {
      setModuleId(Number(id)) // kasih tau camera modul mana
    }
  }, [id, setModuleId])
  // END: access camera and location

  const handlePopstate = (event) => {
    // Show confirmation only if the user wants to leave the current page
    if (event.state) {
      if (!modules?.startQuestion) {
        return true
      } else {
        setOpen(true)
        navigate(location.pathname, { replace: true })
        return
      }
    }
  }
  useEffect(() => {
    window.addEventListener('popstate', function (e) {
      handlePopstate(e)
    })

    return () => {
      window.removeEventListener('popstate', function (e) {
        handlePopstate(e)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, location.pathname, modules?.startQuestion, setOpen])

  // START: set flag before unload
  useEffect(() => {
    if (isEnded) {
      window.onbeforeunload = null
      return
    }

    const warnBeforeUnload = (e) => {
      isBeforeUnloadRef.current = true
      e.preventDefault()
      e.returnValue = 'Leave Page?'
    }

    window.addEventListener('beforeunload', warnBeforeUnload)
    window.onbeforeunload = warnBeforeUnload

    return () => {
      window.removeEventListener('beforeunload', warnBeforeUnload)
      window.onbeforeunload = null
    }
  }, [isEnded])

  useAntiFocus({
    onBlur: () => {
      if (isEnded) return
      if (isBeforeUnloadRef.current) return

      playWarningBeep()
      addLog(user.id, id, 'Berpindah/Menyembunyikan Tab')
    },
    onHidden: () => {
      if (isEnded) return
      if (isBeforeUnloadRef.current) return

      playWarningBeep()
      addLog(user.id, id, 'Berpindah/Menyembunyikan Tab')
    },
  })

  // START: audio warning
  useEffect(() => {
    const shouldUnlock = localStorage.getItem('audioUnlockedIntent') === 'true'
    if (!shouldUnlock) return

    const ctx = getAudioContext()

    // 🔑 unlock via user gesture minimal
    const unlock = () => {
      if (ctx.state === 'suspended') {
        ctx.resume()
      }
      document.removeEventListener('click', unlock)
      document.removeEventListener('keydown', unlock)
    }

    document.addEventListener('click', unlock)
    document.addEventListener('keydown', unlock)

    return () => {
      document.removeEventListener('click', unlock)
      document.removeEventListener('keydown', unlock)
    }
  }, [])
  // END: audio warning



  useEffect(() => {
    const reset = () => {
      // browser gak jadi unload → user klik "Cancel"
      isBeforeUnloadRef.current = false
    }

    window.addEventListener('focus', reset)
    return () => window.removeEventListener('focus', reset)
  }, [])
  // END: set flag before unload

  useEffect(() => {
    if (isEnded) {
      stopCapture()
      window.onbeforeunload = null
    }
  }, [isEnded, stopCapture])

  function handleData(moduleType, data) {
    if (5 === modulesType.MULTIPLE) {
      // eslint-disable-next-line array-callback-return
      const newData = data?.filter((q) => {
        if (!q.pilihan_1 && !q.pilihan_2 && !q.pilihan_3 && !q.pilihan_4) {
          return false
        } else {
          return true
        }
      })

      return newData?.map((q, idx) => renderQuestion(moduleType, q, idx))
    } else {
      const newData = data?.map((q, idx) => renderQuestion(moduleType, q, idx))
      return newData
    }
  }

  if (!moduleTypeIncludes.includes(modules.tipe_modul)) {
    return (
      <Box
        height={'100%'}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
      >
        <Typography fontWeight={700}>Oops!</Typography>
        <br />
        <Typography>
          Maaf soal ini belum tersedia, Dika Psikotes akan langsung menginfokan jika tersedia atau
          hubungi Dika Psikotes 😀
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/')}
          sx={{
            mt: 3,
            color: 'white',
            fontWeight: 700,
          }}
        >
          Kembali
        </Button>
      </Box>
    )
  }
  return checkDoneTask ? (
    <Dialog open={showModal}>
      <DialogContent>Module sudah pernah dikerjakan.</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            setShowModal(false)
            removeLocalStorageData('module')
            removeLocalStorageData('question')
            removeLocalStorageData('camera_capture_log')
            window.location.href = (process.env.REACT_APP_BASE_NAME || '') + '/'
          }}
          sx={{
            backgroundColor: ({ palette }) => palette.warning.light,
            color: 'white',
          }}
        >
          Kembali
        </Button>
      </DialogActions>
    </Dialog>
  ) : (
    <Box height={'100%'} width={'100%'}>
      <React.Fragment>
        <Box sx={{ filter: (isCameraBlocked || isLocationBlocked) ? 'blur(8px)' : 'none', transition: '0.3s ease' }}>
          {!isLoading ? (
            <React.Fragment>
              <Wizard onTestEnded={() => setIsEnded(true)}>
                {handleData(modules.tipe_modul, data?.data)}
              </Wizard>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {[...Array(5)].map((_, idx) => (
                <Skeleton
                  key={idx}
                  height={idx === 0 ? '250px' : '80px'}
                  width={'100%'}
                  sx={{
                    transform: 'scale(1,.8)',
                  }}
                />
              ))}
            </React.Fragment>
          )}
        </Box>
      </React.Fragment>

      <Dialog open={open}>
        <DialogContent>Sesi masih berlangsung harap untuk menyelesaikan sesi ini</DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
            sx={{
              backgroundColor: ({ palette }) => palette.warning.light,
              color: 'white',
            }}
          >
            Lanjutkan
          </Button>
        </DialogActions>
      </Dialog>

      <ProctorOverlay
        open={isCameraBlocked}
        title="⚠️ Kamera nonaktif"
      />

      <ProctorOverlay
        open={isLocationBlocked}
        title="⚠️ Lokasi nonaktif"
      />

      <ScreenshotDialog />
    </Box>
  )
}

export default QuestionPage

function renderQuestion(moduleType, question, idx) {
  switch (moduleType) {
    case modulesType.MULTIPLE:
      return <MultiQuestion key={idx} dataQuestion={question} indices={idx + 1} />

    case modulesType.ENUM:
      return <EnumQuestion key={idx} dataQuestion={question} indices={idx + 1} />

    case modulesType.MULTIPLE_AB:
      return <MultipleABQuestion key={idx} dataQuestion={question} indices={idx + 1} />

    case modulesType.ESSAY_LENGTH:
      return <EssayLength key={idx} dataQuestion={question} indices={idx + 1} />

    case modulesType.DISC:
      return <DISCQuestion key={idx} dataQuestion={question} indices={idx + 1} />

    default:
      return (
        <Box key={idx}>
          <Typography>
            Oops! <br />
            Maaf soal belum ada, stay tuned terus ya atau akan segera dikabarkan 😀
          </Typography>
        </Box>
      )
  }
}
